<mat-form-field class="report-ipt2" appearance="outline">
    <mat-select id="dropdown{{index}}" (selectionChange)="filterCondition($event)" [placeholder]="placeHolder">
      <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
      <mat-option>
        <ngx-mat-select-search [formControl]="userServerSideFilteringCtrl" [searching]="searching" placeholderLabel="UserName" >
          <span ngxMatSelectNoEntriesFound>No entries found</span>
        </ngx-mat-select-search>
      </mat-option>
      <mat-option  *ngFor="let user of filteredServerSideUsers | async" [value]="user.pk_userid" id="{{user.pk_userid}}">
        {{user.user_fullname}}
      </mat-option>
    </mat-select>
  </mat-form-field>